import React, { FC } from 'react'

import { IconPlaceholderProps } from './IconPlaceholder.types'
import * as Styled from './styles/IconPlaceholder.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPlaceholder: FC<IconPlaceholderProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPlaceholderProps['size'],
  isResponsive = false,
}: IconPlaceholderProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M9.033 5.03v-1 1Zm34 0h1v-1h-1v1Zm-38 34h-1 1Zm33.032-27.68a1 1 0 0 0-1.415-1.415l1.415 1.415ZM9.858 36.728a1 1 0 1 0 1.414 1.414l-1.414-1.414ZM11.35 9.935a1 1 0 0 0-1.415 1.415l1.415-1.415Zm25.378 28.207a1 1 0 1 0 1.414-1.414l-1.414 1.414ZM5 23a1 1 0 1 0 0 2v-2Zm38 2a1 1 0 1 0 0-2v2ZM25 5a1 1 0 1 0-2 0h2Zm-2 38a1 1 0 1 0 2 0h-2ZM9.033 6.03h34v-2h-34v2Zm33-1v34h2v-34h-2Zm0 34a3 3 0 0 1-.88 2.121l1.415 1.414a5 5 0 0 0 1.465-3.535h-2Zm-.88 2.121a3 3 0 0 1-2.12.879v2a5 5 0 0 0 3.535-1.465l-1.414-1.414Zm-2.12.879h-30v2h30v-2Zm-30 0a3 3 0 0 1-2.122-.879l-1.414 1.414a5 5 0 0 0 3.536 1.465v-2Zm-2.122-.879a3 3 0 0 1-.878-2.121h-2a5 5 0 0 0 1.464 3.535l1.414-1.414Zm-.878-2.121v-30h-2v30h2Zm0-30a3 3 0 0 1 .878-2.121L5.497 5.494A5 5 0 0 0 4.032 9.03h2Zm.878-2.121a3 3 0 0 1 2.122-.879v-2a5 5 0 0 0-3.536 1.464L6.911 6.91Zm29.74 3.026L9.857 36.728l1.414 1.414L38.065 11.35 36.65 9.935ZM9.934 11.35l26.793 26.792 1.414-1.414L11.35 9.935 9.935 11.35ZM5 25h38v-2H5v2ZM23 5v38h2V5h-2Z'
          fill='#0D0D0D'
        />
        <path
          d='M24 43c10.493 0 19-8.507 19-19S34.493 5 24 5 5 13.507 5 24s8.507 19 19 19Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPlaceholder
